import { executeHttpRequest } from '../epics/api';

export const LOAD_FREELANCERS_PAYROLL = 'LOAD_FREELANCERS_PAYROLL';
export const LOADED_FREELANCERS_PAYROLL_ERROR =
    'LOADED_FREELANCERS_PAYROLL_ERROR';
export const LOADED_FREELANCERS_PAYROLL_SUCCESS =
    'LOADED_FREELANCERS_PAYROLL_SUCCESS';

export function fetchPayroll(searchParams) {
    return dispatch => {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        dispatch(toggleFetchPayroll());
        executeHttpRequest(`freelancers/?${searchParams.toString()}`)
            .then(response => {
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                dispatch(loadPayroll(response));
            })
            .catch(error => {
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    dispatch(
                        // eslint-disable-next-line @typescript-eslint/no-use-before-define
                        loadPayrollFail(
                            `Oops, something went wrong. Status code ${error.response.status}`,
                        ),
                    );
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    // eslint-disable-next-line no-console
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    // eslint-disable-next-line no-console
                    console.log('Error', error.message);
                    // eslint-disable-next-line @typescript-eslint/no-use-before-define
                    dispatch(loadPayrollFail('Oops, something went wrong'));
                }
            });
    };
}

function toggleFetchPayroll() {
    return {
        type: LOAD_FREELANCERS_PAYROLL,
    };
}

function loadPayroll(response) {
    return {
        type: LOADED_FREELANCERS_PAYROLL_SUCCESS,
        payload: response.data,
    };
}

function loadPayrollFail(message) {
    return {
        type: LOADED_FREELANCERS_PAYROLL_ERROR,
        payload: message,
    };
}
